<template>
  <div class="bg-gradient-to-b from-transparent to-blue-50">
    <ASiteContainer>
      <div class="flex flex-col w-full items-start relative">
        <div class="flex flex-col w-full sm:flex-row">
          <div class="flex items-center">
            <div class="flex flex-col sm:mr-12 items-start">
              <ALogo />

              <p
                class="text-sm max-w-72 font-medium text-gray-500 sm:mt-2 sm:mb-3"
              >
                {{ $t("elements.footer.description") }}
              </p>
            </div>
          </div>

          <div
            class="sm:order-4 flex sm:flex-col sm:ml-auto sm:mt-0 mt-4 items-start sm:items-end"
          >
            <ASelectUiLocale class="sm:order-1 sm:mb-3 sm:mt-1 relative z-10" />
          </div>

          <div
            class="flex mt-4 sm:mt-0 justify-between sm:justify-start sm:space-x-16 sm:pr-8 items-center"
          >
            <AFooterLinks
              :title="$t('elements.footer.usefullLinks.title')"
              links-classes="font-medium"
              title-classes="font-black text-lg"
              :links="[
                {
                  to: $localePath({ name: 'help' }),
                  label: $t('elements.footer.usefullLinks.links.help'),
                },
                {
                  to: $localePath({ name: 'legals-who-we-are' }),
                  label: $t('elements.footer.usefullLinks.links.whoWeAre'),
                },
                {
                  to: $localePath({ name: 'articles' }),
                  label: $t(
                    'elements.footer.usefullLinks.links.inspireYourTrip',
                  ),
                },
                {
                  to: $localePath({ name: 'legals-privacy' }),
                  label: $t('elements.footer.usefullLinks.links.privacy'),
                },
                {
                  to: $localePath({ name: 'legals' }),
                  label: $t('elements.footer.usefullLinks.links.legals'),
                },
              ]"
            />
            <AFooterLinks
              v-if="destinations?.length"
              :title="$t('elements.footer.discover.title')"
              links-classes="font-medium"
              title-classes="font-black text-lg"
              :links="
                destinations.map((destination) => ({
                  to: $localePath({
                    name: 'destinations-slug',
                    params: { slug: destination.slug },
                  }),
                  titleAttr: destination.name,
                  label: truncate(destination.name, 35),
                }))
              "
            />
            <AFooterLinks
              v-if="!$device.isMobile && trips?.length"
              :title="$t('elements.footer.trips.title')"
              links-classes="font-medium"
              title-classes="font-black text-lg"
              :links="
                trips.map((trip) => ({
                  to: $localePath({
                    name: 'trips-slug',
                    params: { slug: trip.slug },
                  }),
                  titleAttr: trip.name,
                  label: truncate(trip.name, 35),
                }))
              "
            />
          </div>

          <div
            class="flex flex-col items-end space-y-4 sm:absolute sm:right-0 sm:top-16 sm:mt-0 mt-6"
          >
            <WhatsAppButton
              class="sm:w-auto w-full justify-center"
              :label="$t('elements.footer.tchatOption')"
            />
            <UButton
              :to="$localePath({ name: 'become-partner' })"
              color="primary"
              class="w-full sm:w-auto sm:h-11 sm:pt-[14px] sm:px-5 rounded-lg text-[0.9rem] bg-gradient-to-r from-primary to-cyan-500 py-4 shadow justify-center"
              size="xl"
            >
              {{ $t("general.becomePartner") }}
            </UButton>
          </div>
        </div>

        <hr class="my-12 w-full" />

        <div class="flex items-center space-x-2 mb-12">
          <AFooterCopyright
            :show-agency-link="false"
            :brand="$t('elements.footer.copyright')"
            class="font-medium"
          />
          <p class="text-sm font-medium text-gray-500">&bull;</p>
          <NuxtLink
            :to="$localePath({ name: 'legals-gcu' })"
            class="text-sm font-medium text-gray-500"
          >
            {{ $t("elements.footer.gcu") }}
          </NuxtLink>
        </div>
      </div>
    </ASiteContainer>
  </div>
</template>

<script lang="ts" setup>
const { data: destinations, error: destinationsError } = await useFetch(
  '/api/destinations/footer',
  {
    query: {
      limit: '5',
    },
  },
)

assertDefined(destinations, destinationsError)

const { data: trips, error: tripsError } = await useFetch('/api/trips/footer', {
  query: {
    limit: '5',
  },
})

assertDefined(trips, tripsError)
</script>
